export default "__VITE_ASSET__vROsEtzS__"